import React from "react";
import { Check, ArrowRight, ArrowLeft, Loader2, Coffee } from "lucide-react";
import { SumRow, ErrorBox } from "@/components/booking/parts";

export const Step4Summary = ({ ctx }) => {
  const {
    t, v, selection, datesValid, fmtRange, form, nightsCount, effGuests, roomName,
    accepted, setAccepted, state, confirm,
  } = ctx;
  if (!selection) return null;
  return (
    <div className="space-y-6" data-testid="step-summary">
      <button data-testid="back-details-btn" onClick={() => window.history.back()} className="inline-flex items-center gap-2 text-sm text-[#1D3557] hover:underline">
        <ArrowLeft className="w-4 h-4" /> {v("backBtn")}
      </button>
      <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A]">{v("summaryTitle")}</h2>

      <div data-testid="booking-summary" className="rounded-2xl border-2 border-[#1D3557]/20 overflow-hidden">
        <div className="divide-y divide-black/5">
          <SumRow label={v("sumDates")} value={datesValid ? fmtRange(form.arrival, form.departure) : ""} />
          <SumRow label={v("sumNights")} value={`${nightsCount} ${nightsCount === 1 ? v("night") : v("nights")}`} />
          <SumRow label={v("sumGuests")} value={`${effGuests} ${effGuests === 1 ? v("guest") : v("guests")}`} />
          <SumRow label={selection.rooms.length > 1 ? v("sumRooms") : v("sumRoom")} value={selection.rooms.map(roomName).join(" + ")} />
          <SumRow label={v("sumBreakfast")} value={<span className="inline-flex items-center gap-1.5 text-[#2A4B3C]"><Coffee className="w-4 h-4" /> {v("breakfastYes")}</span>} />
        </div>
        {selection.total != null && (
          <div className="flex items-baseline justify-between px-5 py-4 bg-[#F2EFEB]">
            <span className="text-sm text-[#5C5C5C]">{v("sumTotal")}</span>
            <span data-testid="summary-total" className="font-display text-3xl text-[#1A1A1A]">€ {Math.round(selection.total)}</span>
          </div>
        )}
      </div>

      <div data-testid="ota-saving" className="flex items-start gap-2 text-sm text-[#2A4B3C] bg-[#2A4B3C]/8 rounded-xl px-4 py-3">
        <Check className="w-4 h-4 flex-shrink-0 mt-0.5" /> {v("otaSaving")}
      </div>

      <p className="text-xs text-[#5C5C5C] leading-relaxed">{t("booking.quote.note")}</p>

      <label className="flex items-start gap-3 text-sm text-[#1A1A1A] cursor-pointer">
        <input type="checkbox" data-testid="input-accept-terms" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} className="w-4 h-4 mt-0.5 accent-[#1D3557] flex-shrink-0" />
        <span>{t("booking.labels.acceptTerms")} <a href="#terms" className="text-[#1D3557] underline underline-offset-2">↓</a></span>
      </label>

      {state.error && <ErrorBox msg={state.error} />}

      <button data-testid="confirm-booking-btn" onClick={confirm} disabled={state.submitting}
        className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#1D3557] text-white font-medium text-lg hover:bg-[#345B73] transition-all disabled:opacity-60">
        {state.submitting ? <><Loader2 className="w-5 h-5 animate-spin" /> {t("booking.labels.submitting")}</> : <>{v("confirmBtn")} <ArrowRight className="w-5 h-5" /></>}
      </button>
    </div>
  );
};
